import script from "./CategoryLink.vue?vue&type=script&lang=ts&setup=true"
export * from "./CategoryLink.vue?vue&type=script&lang=ts&setup=true"

import "./CategoryLink.vue?vue&type=style&index=0&id=181cebde&scoped=true&lang=less"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-181cebde"]])

export default __exports__